import {
    FETCH_WEBSITE,
    SAVE_WEBSITE,
} from '../types';
import api from '../api';

export const fetchWebsite = (chainId) => {
    return {
        type: FETCH_WEBSITE,
        payload: api.websites.get(chainId),
    };
};

export const saveWebsite = (website) => {
    if (website.id) {
        return {
            type: SAVE_WEBSITE,
            payload: api.websites.update(website),
            meta: { websiteId: website.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_WEBSITE,
            payload: api.websites.create(website),
            meta: { toastSuccess: true }
        };
    }
};
